import { useRouter } from "next/router";
import React from "react";

import useApiQuery from "lib/api/useApiQuery";
import getQueryParamString from "lib/router/getQueryParamString";
import { ADDRESS_SIGNED_AUTHORIZATION } from "stubs/address";

interface Props {
  enabled: boolean;
  withPlaceholderData?: boolean;
}

const PLACEHOLDER_COUNT = 10;

export default function useAddressSignedAuthorizationsQuery({
  enabled,
  withPlaceholderData = true,
}: Props) {
  const router = useRouter();
  const hash = getQueryParamString(router.query.hash);

  const placeholderData = React.useMemo(() => {
    return Array.from(
      { length: PLACEHOLDER_COUNT },
      () => ADDRESS_SIGNED_AUTHORIZATION,
    );
  }, []);

  const query = useApiQuery("general:address_signed_authorizations", {
    pathParams: { hash },
    queryOptions: {
      enabled: enabled && Boolean(hash),
      placeholderData: withPlaceholderData ? placeholderData : undefined,
    },
  });

  return React.useMemo(
    () => ({
      hash,
      query,
    }),
    [hash, query],
  );
}
